import InepIndexPage from "@/Pages/Inep/index.vue";

export default [
  {
    path: "/inep/",
    name: "inep",
    component: InepIndexPage,
  },
];
